import * as React from 'react'
import DatePicker from 'react-datepicker'
import {connect} from 'react-redux'
import {AttachmentsViewer} from '../../core/components/Controls/Attachments/AttachmentsViewer2'
import {CsSelector} from '../../core/components/Controls/CsSelector'
import OverlayLoader from '../../core/components/Loading/OverlayLoading'
import {IPopupDispatcher, ISourcesDispatcher} from '../../core/interfaces/dispatchers'
import {AttachmentInfo, AttachmentInfos} from '../../core/interfaces/models'
import {IFeatureLayerInfos} from '../../core/interfaces/reducers'
import {Feature} from '../../core/models'
import {appPopupDispatcher} from '../../dispatchers/appPopupDispatcher'
import {updateInputData, updateInputDataLayers, validate} from '../../dispatchers/appRegImportDispatcher'
import {appSourcesDispatcher} from '../../dispatchers/appSourcesDispatcher'
import {IAppStore} from '../../interfaces/reducers'
import {IInputData} from '../../interfaces/reducers/IRegImport'
import {LocationSelector} from '../App/LocationSelector'

interface OwnProps {
  inputData: IInputData
  layerInfos: IFeatureLayerInfos
}

interface DispatchProps extends ISourcesDispatcher, IPopupDispatcher {
  updateInputData: typeof updateInputData
  updateInputDataLayers: typeof updateInputDataLayers
  validate: typeof validate
}

type Props = DispatchProps & OwnProps

const AppImportControlClass = (props: Props) => {
  const getProjectionSelector = (): JSX.Element => {
    return (
      <CsSelector
        selected={props.inputData.dataCS}
        onChange={s => props.updateInputData({...props.inputData, dataCS: s})}
        className="form-control"
      />
    )
  }

  const getFileTypeSelector = (): JSX.Element => {
    return (
      <select
        className={'form-control'}
        value={props.inputData.Edits}
        onChange={e => {
          props.updateInputData({
            ...props.inputData,
            Edits: parseInt(e.target.value),
            layerNames: {
              ...props.inputData.layerNames,
              oParcelBlockLayer: props.inputData.layerNames.oParcelLayer,
              parcelBlockLayer: props.inputData.layerNames.parcelLayer
            }
          })
        }}
      >
        <option value={0}>{'Линеен'}</option>
        <option value={1}>{'Топологичен'}</option>
      </select>
    )
  }

  const getAttachmentsControl = () => {
    const adds: AttachmentInfos = {}
    if (props.inputData.file) {
      adds[props.inputData.file.name] = props.inputData.file
    }
    return (
      <div style={{margin: '5px'}}>
        <AttachmentsViewer
          attachments={{}}
          deletes={{}}
          updates={{}}
          adds={adds}
          acceptTypes={'.dxf,.dwg'}
          maxNumber={1}
          onAttachmentsChange={changes => {
            const addedFiles = Object.keys(changes.adds)
            let file: AttachmentInfo | undefined
            if (addedFiles.length > 0) {
              file = changes.adds[addedFiles[0]]
            }
            props.updateInputData({...props.inputData, file: file})
          }}
          feature={new Feature({})}
          uploadToArchive={false}
        ></AttachmentsViewer>
      </div>
    )
  }

  const getExecuteButton = () => {
    return (
      <button
        type="button"
        className="button width"
        disabled={!props.inputData.file || !props.inputData.location || !props.inputData.planName}
        onClick={() => {
          props.validate()
        }}
      >
        Валидирай данните
      </button>
    )
  }

  const getDateEditingDatePicker = (date: Date): JSX.Element => {
    return (
      <DatePicker
        dateFormat={'dd.MM.yyyy'}
        className="form-control"
        selected={date}
        onChange={v => {
          const newDate = new Date(v!)
          ;[0, 0, 0, 0].forEach((v, i) => {
            if (v == undefined) {
              return
            }
            if (i == 0) {
              newDate.setHours(v)
            } else if (i == 1) {
              newDate.setMinutes(v)
            } else if (i == 2) {
              newDate.setSeconds(v)
            } else if (i == 3) {
              newDate.setMilliseconds(v)
            }
          })
          newDate.setMinutes(-newDate.getTimezoneOffset())
          props.updateInputData({...props.inputData, planDate: newDate})
        }}
        isClearable={false}
        showYearDropdown
      />
    )
  }

  const getApprovedDateEditingDatePicker = (date?: Date): JSX.Element => {
    return (
      <DatePicker
        dateFormat={'dd.MM.yyyy'}
        className="form-control"
        selected={date}
        onChange={v => {
          if (v) {
            const newDate = new Date(v!)
            ;[0, 0, 0, 0].forEach((v, i) => {
              if (v == undefined) {
                return
              }
              if (i == 0) {
                newDate.setHours(v)
              } else if (i == 1) {
                newDate.setMinutes(v)
              } else if (i == 2) {
                newDate.setSeconds(v)
              } else if (i == 3) {
                newDate.setMilliseconds(v)
              }
            })
            newDate.setMinutes(-newDate.getTimezoneOffset())
            props.updateInputData({...props.inputData, approvedDate: newDate})
          } else {
            props.updateInputData({...props.inputData, approvedDate: undefined})
          }
        }}
        isClearable={true}
        showYearDropdown
      />
    )
  }

  const getLocationSelector = () => {
    return (
      <LocationSelector
        selectedLocation={props.inputData.location}
        selectedSettlemet={props.inputData.settlement}
        onSettlementsChange={(locs, settlement?: Feature, location?: Feature) =>
          props.updateInputData({...props.inputData, settlement, location})
        }
      />
    )
  }
  const getContainer = (content: JSX.Element, title: string | JSX.Element | null, margin?: string): JSX.Element => {
    return (
      <div style={{margin, display: 'flex'}}>
        {title && <div style={{minWidth: '40%', maxWidth: '40%', display: 'flex', alignItems: 'center'}}>{title}</div>}
        {content}
      </div>
    )
  }
  const getPlanNaming = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 10px 0 0'}}
          value={props.inputData.planName}
          onChange={e => props.updateInputData({...props.inputData, planName: e.target.value})}
        ></input>
        {getDateEditingDatePicker(props.inputData.planDate)}
      </div>
    )
  }
  const getPlanApprover = () => {
    return (
      <div style={{display: 'flex', justifyContent: 'strech', width: '100%'}}>
        <input
          className="form-control"
          style={{margin: '0 0 0 0'}}
          value={props.inputData.planApprover}
          onChange={e => props.updateInputData({...props.inputData, planApprover: e.target.value})}
        ></input>
      </div>
    )
  }
  const getExpandingLink = () => {
    return (
      <div style={{minHeight: '40px', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <a
          href=""
          onClick={e => {
            e.preventDefault()
            props.updateInputData({...props.inputData, expanded: !props.inputData.expanded})
          }}
        >
          {props.inputData.expanded ? 'По-малко настройки' : 'Повече настройки'}
        </a>
      </div>
    )
  }

  const getLayerMappings = () => {
    const sectionStyle: React.CSSProperties = {
      border: '1px solid #565656',
      borderRadius: '5px',
      boxSizing: 'border-box',
      marginTop: '5px'
    }
    const sectionStyle2: React.CSSProperties = {
      boxSizing: 'border-box',
      padding: '8px'
    }
    const sectionHeaderStyle: React.CSSProperties = {
      padding: '8px',
      boxSizing: 'border-box',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'cadetblue'
    }
    return (
      <React.Fragment>
        {getExpandingLink()}
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Квартали</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.kvLayer}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, kvLayer: e.target.value})}
              />,
              'Слой за квартали'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.kvBlock}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, kvBlock: e.target.value})}
              />,
              'Име на блок с данни за квартал'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.kvTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, kvTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер на квартал</span>
            )}
          </div>
        </div>
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Общински парцели</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelLayer}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, oParcelLayer: e.target.value})
                }
              />,
              'Слой за общински парцели'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelBlockLayer}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, oParcelBlockLayer: e.target.value})
                }
              />,
              'Слой на блок с данни за парцел'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelBlockName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, oParcelBlockName: e.target.value})
                }
              />,
              'Име на блок с данни за парцел'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер на парцел</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelCadTag}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, oParcelCadTag: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за кадастрален номер на парцел</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelPr1}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelPr1: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 1</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelPr2}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelPr2: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 2</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelPr3}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelPr3: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 3</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelPr4}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelPr4: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 4</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.oParcelPr5}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, oParcelPr5: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 5</span>
            )}
          </div>
        </div>
        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Частни парцели</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelLayer}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, parcelLayer: e.target.value})
                }
              />,
              'Слой за частни парцели'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelBlockLayer}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, parcelBlockLayer: e.target.value})
                }
              />,
              'Слой на блок с данни за парцел'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelBlockName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, parcelBlockName: e.target.value})
                }
              />,
              'Име на блок с данни за парцел'
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер на парцел</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelCadTag}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, parcelCadTag: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за кадастрален номер на парцел</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelPr1}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelPr1: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 1</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelPr2}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelPr2: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 2</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelPr3}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelPr3: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 3</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelPr4}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelPr4: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 4</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.parcelPr5}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, parcelPr5: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за предназначение 5</span>
            )}
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Бордюрна регулация</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.TrotoLayer}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, TrotoLayer: e.target.value})}
              />,
              'Слой за бордюрна регулация'
            )}
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Осова линия</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OSLineLayer}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, OSLineLayer: e.target.value})
                }
              />,
              'Слой за осова линия'
            )}
          </div>
        </div>

        <div style={sectionStyle}>
          <div style={sectionHeaderStyle}>Осова точка</div>
          <div style={sectionStyle2}>
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OTBlockName}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, OTBlockName: e.target.value})
                }
              />,
              'Име на блок с данни за осова точка'
            )}

            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OTNomerTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, OTNomerTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за номер на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OTKotaTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, OTKotaTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за височина на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OTCreatedTag}
                onChange={e =>
                  props.updateInputDataLayers({...props.inputData.layerNames, OTCreatedTag: e.target.value})
                }
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за създател на точката</span>
            )}
            {getContainer(
              <input
                className="form-control"
                value={props.inputData.layerNames.OTDescTag}
                onChange={e => props.updateInputDataLayers({...props.inputData.layerNames, OTDescTag: e.target.value})}
              />,
              <span style={{marginLeft: '15px'}}>- Име на tag в блока с данни за описание на точката</span>
            )}
          </div>
        </div>
      </React.Fragment>
    )
  }

  const getPlanTypeSelector = () => {
    return (
      <select
        className="form-control"
        value={props.inputData.planType}
        onChange={e => props.updateInputData({...props.inputData, planType: parseInt(e.target.value)})}
      >
        <option value={1}>План</option>
        <option value={2}>Изменение</option>
      </select>
    )
  }

  const getClose5cmCheckbox = () => {
    return (
      <input
        type="checkbox"
        checked={props.inputData.cm5Checked}
        onChange={() => props.updateInputData({...props.inputData, cm5Checked: !props.inputData.cm5Checked})}
      ></input>
    )
  }
  const AddIndexesToDuplicateNumbers = () => {
    return (
      <input
        type="checkbox"
        checked={props.inputData.AddIndexesToDuplicateNumbers}
        onChange={() =>
          props.updateInputData({
            ...props.inputData,
            AddIndexesToDuplicateNumbers: !props.inputData.AddIndexesToDuplicateNumbers
          })
        }
      ></input>
    )
  }
  const getEncodingSelector = () => {
    return (
      <input
        type="checkbox"
        checked={props.inputData.cp1251}
        onChange={() => props.updateInputData({...props.inputData, cp1251: !props.inputData.cp1251})}
      ></input>
    )
  }
  const getValidationStatusUI = () => {
    if (props.inputData.loading) {
      if (props.inputData.startedImportGuid) {
        return (
          <div className="import-params-success">
            <div>Успешна валидация на входните параметри</div>
            <div>Номер на импорт: {props.inputData.startedImportGuid}</div>
          </div>
        )
      }
      return <div className="import-loading">В процес на валидация на входните параметри...</div>
    } else {
      if (props.inputData.errors.length > 0) {
        const errors: JSX.Element[] = []
        props.inputData.errors.forEach((e, i) => {
          errors.push(<div key={i}>{e}</div>)
        })
        return <div className="import-params-errors">{errors}</div>
      } else if (props.inputData.startedImportGuid) {
        return (
          <div className="import-params-success">
            <div>Успешна валидация на входните параметри</div>
            <div>Номер на импорт: {props.inputData.startedImportGuid}</div>
          </div>
        )
      }
    }
  }

  return (
    <div style={{padding: '10px', boxSizing: 'border-box'} as React.CSSProperties}>
      <div style={{textAlign: 'center'}}>
        Очаква се DXF/DWG файл.
        <br />
        Фаил с примерни линии и обекти можете да намерите <a href="/resources/samples/sample.dxf">ТУК</a>
      </div>
      <div style={{position: 'relative'}}>
        <OverlayLoader show={props.inputData.loading}></OverlayLoader>
        {getContainer(getAttachmentsControl(), 'Прикачете файл', `10px 0px`)}
        {getContainer(getFileTypeSelector(), 'Тип файл', `10px 0px`)}
        {getContainer(getProjectionSelector(), 'Координатна система на данните от файла', `10px 0px`)}
        {getContainer(getPlanTypeSelector(), 'Тип импорт', `10px 0px`)}
        {getContainer(getLocationSelector(), null, `10px 0px`)}
        {getContainer(getPlanNaming(), 'Заповед № и дата на плана/изменението', `10px 0px`)}
        {getContainer(getPlanApprover(), 'Одобрен от', `10px 0px`)}
        {getContainer(getApprovedDateEditingDatePicker(props.inputData.approvedDate), 'Дата влязъл в сила')}
        {getContainer(getClose5cmCheckbox(), 'Затваряне на квартали под 5см', `10px 0px`)}
        {getContainer(AddIndexesToDuplicateNumbers(), 'Индекс на дублирани УПИ', `10px 0px`)}

        {props.inputData.expanded ? getLayerMappings() : null}
        {getExpandingLink()}
        {getExecuteButton()}
      </div>
      {getValidationStatusUI()}
    </div>
  )
}

const mapStoreToProps = (store: IAppStore) => ({
  inputData: store.regImport.inputData,
  layerInfos: store.layerInfos.featureLayerInfos
})

export const RegImportInputDataControl = connect<OwnProps, DispatchProps>(mapStoreToProps, {
  ...appSourcesDispatcher,
  ...appPopupDispatcher,
  validate,
  updateInputData,
  updateInputDataLayers
})(AppImportControlClass)
